// 位置为空或使用占位坐标时不生成连线，避免把工单绘制到零点或错误机构。
function position(latitude, longitude) {
    if ([latitude, longitude].some(value => value == null || String(value).trim() === '')) return null
    const lat = Number(latitude)
    const lng = Number(longitude)
    if (!Number.isFinite(lat) || !Number.isFinite(lng) || Math.abs(lat) > 90 || Math.abs(lng) > 180 || (lat === 0 && lng === 0)) return null
    return { lat, lng }
}

export function buildRepairConnections(orders) {
    const seen = new Set()
    const connections = []
    orders.forEach(order => {
        // 严格按业务服务方式区分站内/站外，不用坐标距离或地址文本猜测。
        if (order.serviceMethod !== '012002') return
        if (!order.orderId || seen.has(order.orderId)) return
        seen.add(order.orderId)
        const origin = position(order.organLat, order.organLng)
        const destination = position(order.repairLat, order.repairLng)
        if (!order.organId || !origin || !destination) return
        connections.push({ ...order, origin, destination })
    })
    return connections
}
